// DELIVERY-TERMS follow-on: pure view-model of an order's receivables schedule. The API (GET /api/sales-orders/:op `receivables_schedule`)
// reads the due dates from the order's receivable legs (the rows the aging engine ages), so nothing is computed from the order date here.
//   pending  : no receivable yet and the order has terms        -> "due N days after delivery"
//   none     : no receivable yet and no terms                   -> nothing to say
//   schedule : receivable entries exist (one per delivery)      -> actual due dates (first..last when several)
export function scheduleView(s) {
  if (!s) return { mode: 'none', n: null, entries: [], first: null, last: null };
  const entries = s.entries || [];
  if (!entries.length) return { mode: s.payment_days != null ? 'pending' : 'none', n: s.payment_days ?? null, entries, first: null, last: null };
  return { mode: 'schedule', n: s.payment_days ?? null, entries, first: s.first_due ?? null, last: s.last_due ?? null };
}
// One-line due text for a list row / record card: { kind: 'pending'|'date'|'range'|'none', n, first, last }
export function dueLine({ first, last, terms, delivered }) {
  if (first) return first === last || !last ? { kind: 'date', first } : { kind: 'range', first, last };
  if (!delivered && terms != null) return { kind: 'pending', n: terms };
  return { kind: 'none' };
}
